
import { defineComponent } from "vue";
import { router, Routes } from "@/router";
import MainAuthenticationLayout from "../../layouts/main-authentication-layout.vue";
import { useMediaQuery } from "@/composition/use-media-query";
import LoginSubPage from "./components/login-sub-page/login-sub-page.vue";
import LandingPageLoginForm from "./features/landing-page-login-form.vue";
import packageJson from "../../../../../package.json";

export default defineComponent({
  setup() {
    const { isSmallWidth, isSmallerThanLargeWidth } = useMediaQuery();
    return {
      version: packageJson.version,
      isSmallWidth,
      isSmallerThanLargeWidth,
    };
  },
  components: {
    MainAuthenticationLayout,
    LoginSubPage,
    LandingPageLoginForm,
  },
  methods: {
    goToLoginPage: () => router.goTo(Routes.login),
    goToSignUpPage: () => router.goTo(Routes.signUp),
  },
});
